import { ActionOrTriggerListTypeEnum, IActionOrTriggerListPageParams } from "@app/static";
import Link from "next/link";
import { useRouter } from "next/router";
import { PropsWithChildren } from "react";
import { ulid } from "ulid";
import { createActionUtils, IActionData, IActionJavaData, IActionShellData } from "../../../action";
import { childToProjectDataUtils, IChildToProjectData } from "../../../utils";
import { appNamespace } from "../app-namespace";
import { IActionOpenAppUI } from "./IActionOpenApp.UI";
const type = `${appNamespace}openApp`


export interface IActionOpenAppJavaData extends IActionJavaData {
    packageName: string
}

export interface IActionOpenAppData extends IActionData<IActionShellData, IActionOpenAppJavaData> { 
    javaData: IActionOpenAppJavaData
}

function createDefultData(): IActionOpenAppData {
    return {
        id: ulid(),
        type,
        javaData: {
            packageName: ''
        }
    }
}

// function UpdateAppLink({data, children}: {data: IActionOpenAppData}&PropsWithChildren){
//     const packageName = data.javaData.packageName
//     data.javaData
//     console.log('packagename=', packageName)
//     const projectInfo:IChildToProjectData = {}
//     childToProjectDataUtils.actionList.getActionListByProp(data, projectInfo)
//     if(!projectInfo.project?.id || !projectInfo.triggerActionGroup?.id || !projectInfo.triggerAction?.id || !projectInfo.actionGroup?.id){
//         console.error('UpdateAppLink projectInfo is undefined', projectInfo)
//         return
//     }
//     const router = useRouter()
//     const backPath = router.pathname
//     const query:IActionOrTriggerListPageParams = {
//         backPath,
//         projectId: projectInfo.project?.id,
//         triggerActionGroupId: projectInfo.triggerActionGroup?.id,
//         triggerActionId: projectInfo.triggerAction?.id,
//         actionGroupId: projectInfo.actionGroup?.id,
//         type: ActionOrTriggerListTypeEnum.updateAction,
//         actionId: data.id,
//         actionType: type,
//     }
//     return <Link href={{pathname: '/action-list/app-selector', query}}>
//         {children}
//     </Link>
// }
function init(){
}
export const actionOpenAppUtils = createActionUtils(type, init, createDefultData, IActionOpenAppUI)


